import React, { ComponentPropsWithoutRef, useCallback, useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import Distance from '../../../../styled/Distance';
import EnvironmentImageGallery from '../../../../styled/EnvironmentImageGallery';
import { H2 } from '../../../../styled/Heading';

import { formatImage } from '../../../../utils/image';
import { ImagesContext } from '../providers/ImagesProvider';

const EnvironmentImages = (props: ComponentPropsWithoutRef<'div'>) => {
  const { environmentImages, productImages, measurementsImages, setFullscreenIndex } =
    useContext(ImagesContext);

  const thumbnails = useMemo(
    () =>
      environmentImages.map(({ url, altText }) => ({
        url: formatImage(url, { width: 205, height: 205, crop: true, cdn: true }),
        alt: altText,
      })),
    [environmentImages],
  );

  const onImageClick = useCallback(
    (index) => {
      setFullscreenIndex(productImages.length + measurementsImages.length + index);
    },
    [productImages, measurementsImages],
  );

  const onShowAll = useCallback(() => {
    setFullscreenIndex(productImages.length + measurementsImages.length);
  }, [productImages]);

  if (!thumbnails.length) {
    return null;
  }

  return (
    <div {...props}>
      <H2>Inspiration</H2>
      <Distance size="2" />
      <EnvironmentImageGallery
        images={thumbnails}
        onShowAll={onShowAll}
        onImageClick={onImageClick}
      />
    </div>
  );
};

export default EnvironmentImages;
